import { mutations } from "@/constants/state";

export default {
  [mutations.ROOSTER_FORECAST_FETCH_MUTATION]: (state, payload) => {
    state.roosterForecast = payload;
  },
};
